import React from 'react';
import { SidebarPortal } from '@plone/volto/components';

import ContextNavigationView, { type ContextNavigationViewProps } from './View';
import Data, { type ContextNavigationDataProps } from './Data';

export interface ContextNavigationEditProps
  extends Omit<ContextNavigationViewProps, 'data'>,
    Omit<ContextNavigationDataProps, 'data'> {
  selected: boolean;
  pathname?: string;
  data: Record<string, any>;
  [key: string]: any;
}

const ContextNavigationEdit: React.FC<ContextNavigationEditProps> = (props) => {
  return (
    <>
      <h3>Context navigation</h3>
      <ContextNavigationView {...props} />

      <SidebarPortal selected={props.selected}>
        {props.selected && <Data {...props} />}
      </SidebarPortal>
    </>
  );
};

export default ContextNavigationEdit;
